module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sv-034fabc522f105f4c8607f35788250c8.svg";